import React, {Component} from 'react';
import { Nav,Accordion,Button,Row,Col, Card,Table} from 'react-bootstrap';
import $ from 'jquery'
import Footer from './Footer'
import Fixed from './Fixed'
import './all.css'
import news_banner from '../img/news_banner.jpg'
import map from '../img/map.jpg'
import hjqxyl from '../img/hjqxyl.png'
import './all.css'


class AboutService extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <div>
                <Row className='margin0'>
                    <img className="d-block w-100" src={news_banner} />
                </Row>
                <Row className="justify-content-md-center text-center" >
                    <Col xs={12} lg={8} style={{background:'#fff'}}>
                        <Nav className="justify-content-center about_nav" activeKey="/aboutService">
                            <Nav.Item>
                                <Nav.Link href="/aboutService">全球服务网络</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link href="/aboutIntroduce">润脉技术介绍</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link href="/contact">联系我们</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={8}  style={{background:'#fff',margin:'2% 0',padding:'2%'}}>
                        <Accordion defaultActiveKey="0">
                            <Card>
                                <Card.Header>
                                    <Accordion.Toggle as={Button} variant="link" eventKey="0">奥地利（6）</Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="0">
                                    <Table striped bordered hover size="md">
                                            <thead>
                                                <tr>
                                                    <td>诊所名称</td>
                                                    <td>地点</td>
                                                    <td>电话</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Mark</td>
                                                    <td>Otto</td>
                                                    <td>@mdo</td>
                                                </tr>
                                                <tr>
                                                    <td>Jacob</td>
                                                    <td>Thornton</td>
                                                    <td>@fat</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>Larry the Bird</td>
                                                    <td>@twitter</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                </Accordion.Collapse>
                            </Card>
                            <Card>
                                <Card.Header>
                                <Accordion.Toggle as={Button} variant="link" eventKey="1">
                                    比利时（4）
                                </Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="1">
                                <Card.Body>Hello! I'm another body</Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </Col>
                </Row>
                <Footer/>
                <Fixed/>
            </div>
        )
    }
}

export default AboutService;

